import { RouteComponentProps } from 'react-router';

// #region enum
export enum OrderType {
  COLLECTION = 'collection',
  DELIVERY = 'delivery',
}
// #endregion

// #region route types
export interface Routes {
  params: {
    concessionStoreId?: string;
    dlid?: string;
    id?: string;
    lat?: string;
    lng?: string;
    location?: string;
    orderId?: string;
    phone?: string;
    placeId?: string;
    prid?: string;
    type?: OrderType;
    vrid?: string;
  };
}

export type RouteParams = RouteComponentProps<Routes, Routes['params']>;
// #endregion
